Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness'

class Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessAuthor
  constructor: (builder) ->
    @name = builder.getName()
    @profilePhotoUrl = builder.getProfilePhotoUrl()

  getName: =>
    @name

  getProfilePhotoUrl: =>
    @profilePhotoUrl
